import React from 'react';
import GridContainer from '../../../@jumbo/components/GridContainer';
import PageContainer from '../../../@jumbo/components/PageComponents/layouts/PageContainer';
import IntlMessages from '../../../@jumbo/utils/IntlMessages';

import Grid from '@material-ui/core/Grid';
import Divider from '@material-ui/core/Divider';
import AllQuestions from '@jumbo/Dashboards/Tests/AllQuestions';
import { useRouteMatch } from 'react-router-dom';

const breadcrumbs = [
  { label: <IntlMessages id={'sidebar.main'} />, link: '/' },
  { label: <IntlMessages id={'pages.testsPage'} />, link: '/tests' },
  { label: <IntlMessages id={'pages.questionsPage'} />, isActive: 'true' },
];

const Questions = () => {
  const { params } = useRouteMatch();
  return (
    <PageContainer heading={<IntlMessages id="pages.questionsPage" />} breadcrumbs={breadcrumbs}>
      <GridContainer>
        <Grid item xs={12}>
          <div style={{ marginBottom: 10 }}>
            <IntlMessages id="pages.questionsPage.description" />
          </div>
          <Divider />
          <div style={{ marginTop: 24 }}>
            <AllQuestions id={params.id} />
          </div>
        </Grid>
      </GridContainer>
    </PageContainer>
  );
};

export default Questions;
